import { render, staticRenderFns } from "./ScannerOverlay.vue?vue&type=template&id=4284ba0a&scoped=true"
import script from "./ScannerOverlay.vue?vue&type=script&lang=js"
export * from "./ScannerOverlay.vue?vue&type=script&lang=js"
import style0 from "./ScannerOverlay.vue?vue&type=style&index=0&id=4284ba0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284ba0a",
  null
  
)

export default component.exports